@if (data && hasData()) {
<div class="generic-sentiment-container">

  <!-- Top Row: Score Widget and Chart -->
  <div class="top-row">
    <!-- Composite Score Widget -->
    <app-composite-score-widget
      [compositeScore]="compositeScore?.value || 0"
      [title]="'Sentiment Analysis Score'"
      [size]="'medium'">
    </app-composite-score-widget>

    <!-- Sentiment Analysis Chart -->
    <div class="chart-section">
      <div class="chart-header">
        <div class="chart-title-section">
          <h4 class="chart-title">Sentiment Analysis Index</h4>
          <p class="chart-subtitle">{{ getChartSubtitle() }}</p>
        </div>
      </div>

      <!-- Sentiment Analysis Chart -->
      <div class="chart-mobile-wrapper" #chartContainer>
        @if(shouldRenderChart && (results.length > 0 || lineChart.length > 0)) {
        <div class="combo-chart-wrapper">
          <app-bar-line-combo-chart
            [view]="view"
            [scheme]="comboBarScheme"
            [colorSchemeLine]="lineChartScheme"
            [results]="results"
            [lineChart]="lineChart"
            [barBrandName]="firstBrandName || 'Your Brand'"
            [animations]="true"
            [tooltipDisabled]="false"
            [yAxisTickFormatting]="yLeftTickFormat"
            [yLeftAxisScaleFactor]="yLeftAxisScale"
            [yRightAxisScaleFactor]="yRightAxisScale"
            [yRightAxisTickFormatting]="yRightTickFormat"
            [gradient]="false"
            [xAxis]="true"
            [yAxis]="true"
            [legend]="true"
            [legendTitle]="'Brands'"
            [legendPosition]="'right'"
            [showGridLines]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [showRightYAxisLabel]="true"
            [xAxisLabel]="'Sentiment Metrics'"
            [yAxisLabel]="'Score'"
            [yAxisLabelRight]="'Score'"
            [noBarWhenZero]="true"
            [wrapTicks]="false"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </app-bar-line-combo-chart>
        </div>
        } @else if (!shouldRenderChart) {
        <div class="chart-placeholder">
          <p>Chart will load when tab becomes visible...</p>
        </div>
        }
      </div>
    </div>
  </div>

  <!-- Sentiment Radar Chart -->
  @if (sentimentRadarData.length > 0) {
  <div class="radar-chart-section">
    <h3>Sentiment Analysis Radar</h3>
    <app-area-chart [areaChartData]="sentimentRadarData" [scheme]="'vivid'" [animations]="true" [legend]="false" [xAxis]="true" [yAxis]="true" [showXAxisLabel]="false" [showYAxisLabel]="false" [xAxisLabel]="''" [yAxisLabel]="''">
    </app-area-chart>
  </div>
  }

  <!-- Performance Table -->
  @if (tableRows.length > 0) {
  <app-common-performance-table
    [rows]="tableRows"
    [columns]="tableColumns"
    [title]="'Brand Sentiment Performance'">
  </app-common-performance-table>
  }

  <!-- Sentiment Tracking Table -->
  @if (sentimentTrackingTableRows.length > 0) {
  <app-common-performance-table
    [rows]="sentimentTrackingTableRows"
    [columns]="sentimentTrackingTableColumns"
    [title]="'Sentiment Tracking Metrics'">
  </app-common-performance-table>
  }

  <!-- Sentiment Trends Section -->
  @if (sentimentTrends) {
  <app-sentiment-trends
    [sentimentTrends]="sentimentTrends"
    [title]="'Sentiment Trends Analysis'">
  </app-sentiment-trends>
  }

  <!-- Brand Sentiment Insights -->
  @if (genericBrands.length > 0) {
  <div class="generic-insights-section">
    <h3>Brand Sentiment Insights</h3>
    <div class="insights-grid">
      @for (brand of genericBrands; track brand.name) {
      <div class="brand-insight-card">
        <h4>{{ brand.name }}</h4>
        <div class="insight-metrics">
          <div class="metric">
            <span class="metric-label">Overall Sentiment:</span>
            <span class="metric-value">{{ brand.sentiment_score }}/100</span>
          </div>
          @if (brand.overall_reputation_score != null && brand.overall_reputation_score > 0) {
          <div class="metric">
            <span class="metric-label">Overall Reputation:</span>
            <span class="metric-value">{{ brand.overall_reputation_score }}/100</span>
          </div>
          }
          @if (brand.social_media_sentiment != null && brand.social_media_sentiment > 0) {
          <div class="metric">
            <span class="metric-label">Social Media:</span>
            <span class="metric-value">{{ brand.social_media_sentiment }}/100</span>
          </div>
          }
          @if (brand.customer_satisfaction != null && brand.customer_satisfaction > 0) {
          <div class="metric">
            <span class="metric-label">Customer Satisfaction:</span>
            <span class="metric-value">{{ brand.customer_satisfaction }}/100</span>
          </div>
          }
          @if (brand.news_sentiment != null && brand.news_sentiment > 0) {
          <div class="metric">
            <span class="metric-label">News Sentiment:</span>
            <span class="metric-value">{{ brand.news_sentiment }}/100</span>
          </div>
          }
        </div>
        @if (brand.customer_perception) {
        <div class="key-insights">
          <h5>Customer Perception:</h5>
          <p class="insight-text">{{ brand.customer_perception }}</p>
        </div>
        }
        @if (brand.sentiment_trends) {
        <div class="key-insights">
          <h5>Sentiment Trends:</h5>
          <p class="insight-text">{{ brand.sentiment_trends }}</p>
        </div>
        }
        @if (brand.key_insights && brand.key_insights.length > 0) {
        <div class="key-insights">
          <h5>Key Insights:</h5>
          <ul>
            @for (insight of brand.key_insights; track insight) {
            <li>{{ insight }}</li>
            }
          </ul>
        </div>
        }
      </div>
      }
    </div>
  </div>
  }

  <!-- HIDDEN: Sources & Citations (do not remove)
  @if (evidenceSources.length > 0) {
    <app-citation-card
      [citations]="evidenceSources"
      [title]="'Sources & Citations'"
        [displayStyle]="'grid'"
        [maxDisplay]="6">
    </app-citation-card>
  }
  -->
</div>
}

  